// extracted by mini-css-extract-plugin
module.exports = {"Title":"PopupHotLine__Title_33rHp","Description":"PopupHotLine__Description_gJGKF","Tabs":"PopupHotLine__Tabs_2BDYd","Footer":"PopupHotLine__Footer_26fEr"};